import { useState } from "react";
import api from "@/lib/api";
import { Mono } from "./ui";

const WORKFLOW_STEPS = [
  ["draft", "Draft"], ["quality_check", "Quality check"], ["ready", "Ready"],
  ["submitted", "Submitted"], ["approved", "Approved"],
];

export default function WorkflowStepper({ claim, onChanged }) {
  const [busy, setBusy] = useState(false);
  const current = claim.workflow_status || "draft";
  const idx = Math.max(0, WORKFLOW_STEPS.findIndex(([k]) => k === current));
  const history = claim.workflow_history || [];
  const last = history[history.length - 1];

  const setStatus = async (s) => {
    if (s === current || busy) return;
    setBusy(true);
    try {
      await api.post(`/fieldclaim/claims/${claim.id}/workflow`, { status: s });
      onChanged();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-gold-500/25 bg-navy-900/40 p-4" data-testid="claim-workflow">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
        <Mono className="text-[0.55rem] text-white/50">Application status workflow</Mono>
        {last && (
          <span className="text-white/35 text-[0.65rem] font-light" data-testid="workflow-last">
            {WORKFLOW_STEPS.find(([k]) => k === last.status)?.[1] || last.status} · {(last.at || "").slice(0, 16).replace("T", " ")} · {last.by_name}
          </span>
        )}
      </div>
      <div className="flex items-center gap-1 flex-wrap">
        {WORKFLOW_STEPS.map(([k, label], i) => (
          <div key={k} className="flex items-center gap-1">
            {i > 0 && <span className={`h-px w-4 ${i <= idx ? "bg-emerald-400/60" : "bg-white/15"}`} />}
            <button onClick={() => setStatus(k)} disabled={busy} data-testid={`workflow-step-${k}`}
              className={`px-3 py-1.5 text-xs border transition-colors disabled:opacity-60 ${
                i === idx
                  ? "bg-gold-500 text-navy-950 font-semibold border-gold-500"
                  : i < idx
                    ? "border-emerald-400/50 text-emerald-300 hover:bg-emerald-400/10"
                    : "border-white/15 text-white/45 hover:text-gold-300 hover:border-gold-500/40"
              }`}>
              {i < idx ? "✓ " : ""}{label}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
